import { forwardRef, type HTMLAttributes } from 'react';
import cn from 'classnames';

import css from './styles.module.scss';

interface LightColorEffectProps extends HTMLAttributes<HTMLDivElement> {
  lightClassName: string;
}

const LightColorEffect = forwardRef<HTMLDivElement, LightColorEffectProps>(
  ({ lightClassName, ...props }, ref) => {
    return (
      <div ref={ref} {...props} className={cn(css.light, props.className)}>
        <div className="relative w-full h-full">
          <div className={cn(css.lightImage, lightClassName)}></div>
        </div>
      </div>
    );
  },
);

export { LightColorEffect };
